import { useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import ValidateReferralCodeQuery from "lib/queries/referral/ValidateReferralCodeQuery";
import type {
  IValidateReferralCodeQuery,
  IValidateReferralCodeQueryVariables,
} from "lib/queries/referral/__generated__/ValidateReferralCodeQuery.generated";
import { captureReferralCode, getReferralCode } from "lib/referral/referralStorage";

interface UseReferralCaptureResult {
  referralCode: string | null;
  referrerName: string | null;
  isValidating: boolean;
  isValid: boolean | null;
}

export default function useReferralCapture(): UseReferralCaptureResult {
  const [referralCode, setReferralCode] = useState<string | null>(null);
  const [referrerName, setReferrerName] = useState<string | null>(null);
  const [isValid, setIsValid] = useState<boolean | null>(null);

  const [validateCode, { loading: isValidating }] = useLazyQuery<
    IValidateReferralCodeQuery,
    IValidateReferralCodeQueryVariables
  >(ValidateReferralCodeQuery, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data?.validateReferralCode) {
        setIsValid(data.validateReferralCode.isValid);
        setReferrerName(data.validateReferralCode.referrerName || null);
      }
    },
    onError: () => {
      setIsValid(false);
    },
  });

  useEffect(() => {
    const code = captureReferralCode();

    if (code) {
      setReferralCode(code);
      validateCode({ variables: { code } });
    } else {
      const storedCode = getReferralCode();
      if (storedCode) {
        setReferralCode(storedCode);
      }
    }
  }, [validateCode]);

  return {
    referralCode,
    referrerName,
    isValidating,
    isValid,
  };
}
